export default __webpack_public_path__ + "static/dacha-database-5-0bd3aecce398bb0b9d33df1d63d146b4.png";